export const GETWISHLISTREQUEST = 'GETWISHLISTREQUEST'
export const GETWISHLISTSUCCESS = 'GETWISHLISTSUCCESS'
export const GETWISHLISTFAILURE = 'GETWISHLISTFAILURE'

export const POSTWISHLISTREQUEST = 'POSTWISHLISTREQUEST'
export const POSTWISHLISTSUCCESS = 'POSTWISHLISTSUCCESS'
export const POSTWISHLISTFAILURE = 'POSTWISHLISTFAILURE'

